/**
 * JS copied from: https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript
 * Allows to automatically switch color modes based on users system color
 */

/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

document.addEventListener("DOMContentLoaded", async () => {
  if (isLocalStorageAvailable()) {
    initColorModes();
  }
});

function isLocalStorageAvailable() {
  try {
    const test = "__localStorage_test__";

    localStorage.setItem(test, test);
    localStorage.removeItem(test);

    return true;
  } catch (_e) {
    return false;
  }
}

function initColorModes(): void {
  const getStoredTheme = () => localStorage.getItem("theme");
  const setStoredTheme = (theme: string) => localStorage.setItem("theme", theme);

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme();
    if (storedTheme) {
      return storedTheme;
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  };

  const setTheme = (theme: string) => {
    if (theme === "auto") {
      document.documentElement.setAttribute(
        "data-bs-theme",
        window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light",
      );
    } else {
      document.documentElement.setAttribute("data-bs-theme", theme);
    }
  };

  setTheme(getPreferredTheme());

  const showActiveTheme = (theme: string, focus = false) => {
    const themeSwitcher = document.querySelector("#bd-theme") as HTMLElement;

    if (!themeSwitcher) {
      return;
    }

    const themeSwitcherText = document.querySelector("#bd-theme-text") as HTMLElement;
    const activeThemeIcon = document.querySelector(".theme-icon-active use") as HTMLElement;
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`) as HTMLElement;
    const svgUse = btnToActive.querySelector("svg use") as HTMLElement;
    const svgOfActiveBtn = svgUse.getAttribute("href") as string;

    document.querySelectorAll("[data-bs-theme-value]").forEach((element) => {
      element.classList.remove("active");
      element.setAttribute("aria-pressed", "false");
    });

    btnToActive.classList.add("active");
    btnToActive.setAttribute("aria-pressed", "true");
    activeThemeIcon.setAttribute("href", svgOfActiveBtn);

    const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`;
    themeSwitcher.setAttribute("aria-label", themeSwitcherLabel);

    if (focus) {
      themeSwitcher.focus();
    }
  };

  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    const storedTheme = getStoredTheme();
    if (storedTheme !== "light" && storedTheme !== "dark") {
      setTheme(getPreferredTheme());
    }
  });

  window.addEventListener("DOMContentLoaded", () => {
    showActiveTheme(getPreferredTheme());

    document.querySelectorAll("[data-bs-theme-value]").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const theme = toggle.getAttribute("data-bs-theme-value") as string;

        setStoredTheme(theme);
        setTheme(theme);
        showActiveTheme(theme, true);
      });
    });
  });
}
